import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet Our Team Leaders</h2>
          <p>
            The committed professionals dedicated to delivering optimal solutions and services, ensuring excellence in every aspect of our team's contributions.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <a href={d.Link}><img src={d.img} alt="..." className="team-img" /></a>
                    <div className="caption">
                      <a href={d.Link}><h4>{d.name}</h4></a>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
